// @flow
import { httpDelete, httpGet } from '../helpers/helpers.api';

export const getDevices = (after: ?Date): Promise<Response> =>
    after ? httpGet(`devices?after=${after.getTime()}`) : httpGet('devices');

export const getDevice = (deviceId: string): Promise<Response> => httpGet(`devices/${deviceId}`);

export const deleteDevice = (deviceId: string): Promise<Response> => httpDelete(`devices/${deviceId}`);

export const deleteZone = (deviceId: string): Promise<Response> => httpDelete(`zone/${deviceId}`);



// WEBPACK FOOTER //
// ./src/core/api/devices/devices.api.js